import type { Measurement, ReportUpdatePayload } from '@/models/report';

// DRF nests validation errors positionally: measurements[i] is {} for valid
// rows and an error object for failing ones.

function collectMessages(node: unknown, out: string[]): void {
  if (typeof node === 'string') out.push(node);
  else if (Array.isArray(node)) node.forEach((n) => collectMessages(n, out));
  else if (node && typeof node === 'object')
    Object.values(node).forEach((n) => collectMessages(n, out));
}

/** Human-readable description for a failed report PATCH, naming the failing
 *  measurement(s) so the user knows what to fix. */
export function parseReportSaveError(
  errorData: unknown,
  payload: ReportUpdatePayload,
  reportMeasurements: Measurement[]
): string {
  const data = errorData as
    | { detail?: string; measurements?: unknown[] }
    | undefined;

  if (Array.isArray(data?.measurements)) {
    const lines = data.measurements.flatMap((entry, i) => {
      const messages: string[] = [];
      collectMessages(entry, messages);
      if (messages.length === 0) return [];
      const sent = payload.measurements?.[i];
      const name =
        reportMeasurements.find(
          (m) => m.canonicalMeasurement === sent?.canonicalMeasurement
        )?.canonicalMeasurementKey ?? `Measurement ${i + 1}`;
      return [`${name}: ${messages.join(' ')}`];
    });
    if (lines.length > 0) return lines.join('\n');
  }

  if (typeof data?.detail === 'string') return data.detail;
  return 'Failed to save the report. Please try again.';
}
